import each from "lodash/each";

export const FullBgVideo = (): void => {
  const fullBgVideoScope = document.getElementsByClassName("fullBgVideo");
  if (!fullBgVideoScope.length) return;

  each(fullBgVideoScope, scope => {
    const video = scope.getElementsByClassName("fullBgVideo__video");
    if (!video.length) return;

    window.addEventListener("load", () => {
      setTimeout(() => {
        if (video[0].paused) {
          //No autoplay
        } else {
          scope.classList.add("fullBgVideo--playing");
        }
      }, video[0].paused ? 200 : 0);
    });

    each(scope.getElementsByClassName("fullBgVideo__play"), playBtn => {
      playBtn.addEventListener("click", () => {
        video[0].play();
        scope.classList.add("fullBgVideo--playing");
      });
    });
  });
};
